module.exports = __webpack_public_path__ + "img/cover-doctor-final.9f500941.jpg";